
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/freelance-companies",
      function () {
        return require("private-next-pages/freelance-companies.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/freelance-companies"])
      });
    }
  